import { createBrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoute } from './PrivateRoute'
import { Layout } from '../components/Layout'
import { LoginPage } from '../pages/Login'
import { UnauthorizedPage } from '../pages/Unauthorized'
import { AdminDashboard } from '../pages/admin/Dashboard'
import { UsersPage } from '../pages/admin/UsersPage'
import { BillingPage } from '../pages/admin/BillingPage'
import { RepsPage } from '../pages/admin/RepsPage'
import { EmpresasPage } from '../pages/admin/EmpresasPage'
import { FeriadosPage } from '../pages/admin/FeriadosPage'
import { PoliticasPage } from '../pages/admin/PoliticasPage'
import { EscalasPage } from '../pages/admin/EscalasPage'
import { FuncionariosPage } from '../pages/admin/FuncionariosPage'
import { BancoHorasPage } from '../pages/rh/BancoHorasPage'
import { RhDashboard } from '../pages/rh/Dashboard'
import { EspelhoPage } from '../pages/rh/EspelhoPage'
import { EspelhoDetailPage } from '../pages/rh/EspelhoDetailPage'
import { EspelhoMensalPage } from '../pages/rh/EspelhoMensalPage'
import { TratamentoPage } from '../pages/rh/TratamentoPage'
import { FuncionarioDashboard } from '../pages/funcionario/Dashboard'
import { SolicitacoesPage } from '../pages/funcionario/SolicitacoesPage'
import { SuperadminDashboard } from '../pages/superadmin/Dashboard'
import { TenantsPage } from '../pages/superadmin/TenantsPage'
import { RoleRedirect } from '../pages/RoleRedirect'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/unauthorized', element: <UnauthorizedPage /> },

  {
    element: <PrivateRoute allowedRoles={['ADMIN_TENANT', 'GESTOR_RH', 'OPERADOR', 'FUNCIONARIO', 'SUPER_ADMIN']} />,
    children: [{ path: '/', element: <RoleRedirect /> }],
  },

  // ── ADMIN_TENANT ──────────────────────────────────────────────────────────────
  {
    element: <PrivateRoute allowedRoles={['ADMIN_TENANT']} />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: '/admin', element: <AdminDashboard /> },
          { path: '/admin/usuarios', element: <UsersPage /> },
          { path: '/admin/billing', element: <BillingPage /> },
          { path: '/admin/empresas', element: <EmpresasPage /> },
          { path: '/admin/reps', element: <RepsPage /> },
          { path: '/admin/funcionarios', element: <FuncionariosPage /> },
          { path: '/admin/feriados', element: <FeriadosPage /> },
          { path: '/admin/politicas', element: <PoliticasPage /> },
          { path: '/admin/escalas', element: <EscalasPage /> },
        ],
      },
    ],
  },

  // ── GESTOR_RH + ADMIN_TENANT ──────────────────────────────────────────────────
  {
    element: <PrivateRoute allowedRoles={['GESTOR_RH', 'ADMIN_TENANT']} />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: '/rh', element: <RhDashboard /> },
          { path: '/rh/espelho', element: <EspelhoPage /> },
          { path: '/rh/espelho/:id', element: <EspelhoDetailPage /> },
          { path: '/rh/espelho-mensal', element: <EspelhoMensalPage /> },
          { path: '/rh/tratamento', element: <TratamentoPage /> },
          { path: '/rh/banco-horas', element: <BancoHorasPage /> },
        ],
      },
    ],
  },

  // ── FUNCIONARIO / OPERADOR ────────────────────────────────────────────────────
  {
    element: <PrivateRoute allowedRoles={['FUNCIONARIO', 'OPERADOR', 'GESTOR_RH', 'ADMIN_TENANT']} />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: '/funcionario', element: <FuncionarioDashboard /> },
          { path: '/funcionario/solicitacoes', element: <SolicitacoesPage /> },
        ],
      },
    ],
  },

  // ── SUPER_ADMIN ───────────────────────────────────────────────────────────────
  {
    element: <PrivateRoute allowedRoles={['SUPER_ADMIN']} />,
    children: [
      {
        element: <Layout superadmin />,
        children: [
          { path: '/superadmin', element: <SuperadminDashboard /> },
          { path: '/superadmin/tenants', element: <TenantsPage /> },
        ],
      },
    ],
  },

  { path: '*', element: <Navigate to="/" replace /> },
])
